// InfoSectionData.js

const InfoSectionData = {
  title: "Deploy digital signage that enriches customer and employee experiences.",
  cards: [
    {
      title: "Captivate Customers",
      description: "Showcase enticing offers and product highlights to boost sales.",
    },
    {
      title: "Engage Employees",
      description: "Share company news and updates to foster a connected team.",
    },
    {
      title: "Modernize Your Menu",
      description: "Dynamic digital menu boards make it easy to engage customers.",
    },
    {
      title: "Guide with Ease",
      description: "Clear wayfinding solutions ensure seamless navigation for all.",
    },
  ],
};

export default InfoSectionData;
